import styled from "@emotion/styled";

import { FONT_WEIGHT_SEMI_BOLD } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";

import { useLocaleOptions } from "../../../l10n/useLocaleOptions.ts";
import type { localeConditionBuilder } from "./localeConditionBuilder";

const Container = styled.div``;

const Title = styled.span``;

const Value = styled.span<{ $status: "selected" | "fetching" | "not-selected" }>`
  color: ${({ $status, theme }) => ($status === "selected" ? theme.secondary : theme.generalTextIconVariant)};

  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
  font-style: ${({ $status }) => ($status !== "not-selected" ? "normal" : "italic")};
`;

export const LocaleConditionSummary: typeof localeConditionBuilder.views.summary = ({ config: { locale } }) => {
  const formatMessage = useFormatMessage(formatStrings);
  const options = useLocaleOptions();

  const label = options.find(({ value }) => value === locale)?.label;

  const status = label ? "selected" : "not-selected";

  return (
    <Container>
      <Title>Locale is</Title> <Value $status={status}>{label ?? formatMessage("notSelected")}</Value>
    </Container>
  );
};

const formatStrings = {
  notSelected: {
    en: "not selected...",
  },
};
